import { api } from "@shared/api/client";
import type {
  CalidadControlModificacion,
  CalidadControlModificacionPayload,
} from "../../../types/control-modificaciones";
import type {
  CalidadIncidencia,
  CalidadIncidenciaPayload,
  CalidadIncidenciasQuery,
  CalidadIncidenciasResponse,
  CalidadNcpFicha,
  CalidadNcpFichaPayload,
  CalidadNcpFichaResponse,
} from "../types/calidad";

export async function getCalidadIncidencias(
  params: CalidadIncidenciasQuery = {},
  signal?: AbortSignal,
): Promise<CalidadIncidenciasResponse> {
  const search = params.search?.trim();
  const numero = params.numero?.trim();

  const requestParams = {
    ...(numero ? { numero } : {}),
    ...(search ? { search } : {}),
    ...(params.tipo_origen ? { tipo_origen: params.tipo_origen } : {}),
    ...(params.tipo ? { tipo: params.tipo } : {}),
    ...(params.page ? { page: params.page } : {}),
    ...(params.per_page ? { per_page: params.per_page } : {}),
  };

  const { data } = await api.get<CalidadIncidenciasResponse>(
    "/certificaciones/iso-9001-14001/incidencias",
    {
      params: requestParams,
      signal,
    },
  );

  return data;
}

export async function createCalidadIncidencia(
  payload: CalidadIncidenciaPayload,
): Promise<CalidadIncidencia> {
  const { data } = await api.post<{ ok: boolean; data: CalidadIncidencia }>(
    "/certificaciones/iso-9001-14001/incidencias",
    payload,
  );

  return data.data;
}

export async function updateCalidadIncidencia(
  incidenciaId: number,
  payload: CalidadIncidenciaPayload,
): Promise<CalidadIncidencia> {
  const { data } = await api.put<{ ok: boolean; data: CalidadIncidencia }>(
    `/certificaciones/iso-9001-14001/incidencias/${incidenciaId}`,
    payload,
  );

  return data.data;
}

export async function deleteCalidadIncidencia(
  incidenciaId: number,
): Promise<void> {
  await api.delete(`/certificaciones/iso-9001-14001/incidencias/${incidenciaId}`);
}

export async function getCalidadNcpFicha(
  incidenciaId: number,
): Promise<CalidadNcpFicha> {
  const { data } = await api.get<CalidadNcpFichaResponse>(
    `/certificaciones/iso-9001-14001/incidencias/${incidenciaId}/ficha-ncp`,
  );

  return data.data;
}

export async function updateCalidadNcpFicha(
  incidenciaId: number,
  payload: CalidadNcpFichaPayload,
): Promise<CalidadNcpFicha> {
  const { data } = await api.put<{ ok: boolean; data: CalidadNcpFicha }>(
    `/certificaciones/iso-9001-14001/incidencias/${incidenciaId}/ficha-ncp`,
    payload,
  );

  return data.data;
}

export async function createCalidadIncidenciaControlModificacion(
  payload: CalidadControlModificacionPayload,
): Promise<CalidadControlModificacion> {
  const { data } = await api.post<{
    ok: boolean;
    data: CalidadControlModificacion;
  }>("/certificaciones/iso-9001-14001/incidencias/control-modificaciones", payload);

  return data.data;
}

export async function updateCalidadIncidenciaControlModificacion(
  id: number,
  payload: CalidadControlModificacionPayload,
): Promise<CalidadControlModificacion> {
  const { data } = await api.put<{
    ok: boolean;
    data: CalidadControlModificacion;
  }>(`/certificaciones/iso-9001-14001/incidencias/control-modificaciones/${id}`, payload);

  return data.data;
}

export async function deleteCalidadIncidenciaControlModificacion(
  id: number,
): Promise<void> {
  await api.delete(`/certificaciones/iso-9001-14001/incidencias/control-modificaciones/${id}`);
}
